export const EXTENSION = Object.freeze({
  pdf: "pdf",
  csv: "csv",
  txt: "txt",
});

export default {};
